// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from "@angular/router";

// Afidium
import { ProcessingDetailComponent } from './processing-detail.component';
import { ProcessingDetailRouting } from './processing-detail.routing';
import { LoaderModule } from "libraries/component/loader/loader.module";
import { NotificationModule } from "libraries/component/notification/notification.module";
import { CardModule } from "libraries/ui_card/card.module";
import { BookingModule } from '../../shared/components/booking/booking.module';
import { DatePipeModule } from 'libraries/date/date.module';
import { ProcessingStatusModule } from '../../shared/components/processing-status/processing-status.module';
import { BtnModule } from 'libraries/ui_button/btn.module';
import { ProcessingInfoComponent } from './components/processing-info.component';
import { ProcessingTaskListComponent } from './components/processing-task-list.component';
import { ProcessingTaskComponent } from './components/processing-task.component';
import { ProcessingTaskStatusComponent } from './components/processing-task-status.component';
import { SashaBreadcrumbModule } from "../../shared/components/breadcrumb/sasha-breacrumb.module";
import { PermissionModule } from "libraries/permission/permission.module";
import { ProcessingIssuingModule } from '../processing-issuing/processing-issuing.module';
import { ProcessingCancellationModule } from '../processing-cancellation/processing-cancellation.module';
import { ProcessingResourceModule } from 'app_sasha/shared/resources/processings/processingResource.module';
import { ProcessingQualityCheckModule } from "../processing-quality-check/processing-quality-check.module";
import { QualityCheckResultModule } from "libraries/component/quality-check-result/quality-check-result.module";
import { TitleServiceModule } from 'app_sasha/shared/services/title/title-service.module';
import { PaginationModule } from "libraries/component/pagination/pagination.module";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import {
    BookingQualityControlDataModule
} from "../../../libraries/component/booking-quality-control-data/booking-quality-control-data.module";

@NgModule({
    imports: [
        BookingModule,
        BtnModule,
        CardModule,
        CommonModule,
        DatePipeModule,
        LoaderModule,
        NotificationModule,
        PermissionModule,
        ProcessingQualityCheckModule,
        ProcessingIssuingModule,
        ProcessingCancellationModule,
        ProcessingDetailRouting,
        ProcessingResourceModule,
        ProcessingStatusModule,
        RouterModule,
        SashaBreadcrumbModule,
        QualityCheckResultModule,
        TitleServiceModule,
        PaginationModule,
        FontAwesomeModule,
        BookingQualityControlDataModule
    ],
    declarations: [
        ProcessingDetailComponent,
        ProcessingInfoComponent,
        ProcessingTaskListComponent,
        ProcessingTaskComponent,
        ProcessingTaskStatusComponent,
    ],
})
export class ProcessingDetailModule { }
